<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div [hidden]="pgLoad">
      <div class="adjust loader-container">
        <div class="loader2"></div>
      </div>
    </div>
    <div class="col-md-12" [hidden]="!pgLoad">
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Business Profile</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home/dashboard"><img
              src="../../../../../../../assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
      <div class="row business_info_container">
        <div class="business_info_details">
          <div class="business_name_div">
            <span>{{businessEntity && businessEntity.businessName}}</span><br>
          </div>
          <div class="business_info">
            <div class="business_address_div">
              <span>
                {{((businessEntity && businessEntity.address[0] && businessEntity.address[0].pincode) == '' ||
                (businessEntity && businessEntity.address[0] && businessEntity.address[0].pincode) == null) ? 'NA' :
                businessEntity && businessEntity.address[0] && businessEntity.address[0].pincode}}
                ,{{((businessEntity && businessEntity.address[0] && businessEntity.address[0].street) == '' ||
                (businessEntity && businessEntity.address[0] && businessEntity.address[0].street) == null) ? 'NA' :
                businessEntity && businessEntity.address[0] && businessEntity.address[0].street}}
                ,{{((businessEntity && businessEntity.address[0] && businessEntity.address[0].city) == '' ||
                (businessEntity && businessEntity.address[0] && businessEntity.address[0].city) == null) ? 'NA' :
                businessEntity && businessEntity.address[0] && businessEntity.address[0].city}}
              </span>
            </div>
            <div class="business_email_div">
              <img src="../../../../../../../assets/images/New_Icons/email-icon.svg">
              <span>{{businessEntity && businessEntity.email == '' || businessEntity && businessEntity.email == null ?
                'NA' : businessEntity && businessEntity.email}}</span>
            </div>
            <div class="business_mobile_number_div">
              <img src="../../../../../../../assets/images/New_Icons/mobile-icon.svg">
              <span>{{businessEntity && businessEntity.dialingCode}} {{businessEntity && businessEntity.mobileNumber
                }}</span>
            </div>
            <div class="business_type_div">
              <img src="../../../../../../../assets/images/New_Icons/company-name-icon.svg">
              <span>{{businessEntity && businessEntity.businessType[0] && businessEntity.businessType[0].name}}</span>
            </div>
            <div class="business_edit" title="Edit Business"
              (click)="getBusinessEntityById(businessEntity && businessEntity.id)">
              <img src="../../../../../../../assets/images/New_Icons/edit.svg">
            </div>
            <div class="business_type_div">
              <img src="../../../../../../../assets/images/New_Icons/delete-icon.svg"
                (click)="navigateToAccountClosurePopupOpenScreen()" style="cursor: pointer;">
              <span style="color: red;">Account Clsoure</span>
            </div>
          </div>
        </div>
      </div>

      <div class="dynamic-form-wrapper" [ngClass]="{
            'floating-panel': formFieldCount <= 7,
            'slide-in-overlay': formFieldCount > 7
          }" *ngIf="showForm">


        <div class="popup-wrapper">

          <button type="button" class="popup-close-beside" (click)="closeForm()" title="Close">
            &times;
          </button>

          <!-- Actual Popup -->
          <div [ngClass]="{
              'form-container-panel': formFieldCount > 7,
              'popup-inner': formFieldCount <= 7
            }">

            <form [formGroup]="registerForm">
              <div class="form-header">
                <div class="form-title">Business</div>
                <!-- ───────── Multi-state action buttons ───────── -->
                 <div>
                     <button type="button" class="add-update-submit-button" (click)="farmProviderUpdate()"
                    [disabled]="businessCreationDoubleClick">
                    <span class="icon">
                      <img src="../../../../assets/images/New_Icons/tick-icon.svg" />
                    </span>
                    <span class="text">
                      Update
                    </span>
                  </button>
                 </div>
              </div>

              <div class="form-container" style="padding-bottom: 0;">
                <span class="container-title">Business Info</span>

                <!-- ───────── Info Banner (kept as‑is) ───────── -->
                <div class="businessCode_info_css" *ngIf="registerBusiness.businessCode">
                  <img src="../../../../assets/images/New_Icons/info-icon.svg" height="20" width="20" />
                  <span>
                    Unique ID will be used to uniquely identify your business and products
                    (Seed) for your potential consumers
                  </span>
                </div>

                <!-- === Section: Business Information === -->
                <div class="form-section">
                  <div class="grid-three-cols">

                    <!-- ───────── BUSINESS NAME ───────── -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Business Name</mat-label>
                      <input matInput id="businessName" autocomplete="off" formControlName="businessName"
                        [(ngModel)]="registerBusiness.businessName" (input)="onBusinessChange()"
                        (keyup)="getBusinessCode()" />

                      <mat-hint>
                        <i>5-30 alaphabetic characters</i>
                      </mat-hint>

                      <!-- Validation -->
                      <mat-error
                        *ngIf="(submitted || f.businessName.touched || f.businessName.dirty) && f.businessName.errors">
                        <ng-container *ngIf="f.businessName.hasError('required')">Business name is
                          <i>required</i>.</ng-container>
                        <ng-container *ngIf="f.businessName.hasError('minlength')">Must be <i>at
                            least 5 characters</i>.</ng-container>
                        <ng-container *ngIf="f.businessName.hasError('maxlength')">Cannot exceed
                          <i>30 characters</i>.</ng-container>
                        <ng-container *ngIf="f.businessName.hasError('pattern')">No numbers or special characters
                          allowed.</ng-container>
                      </mat-error>
                    </mat-form-field>

                    <!-- ───────── BUSINESS CODE (readonly) ───────── -->
                    <mat-form-field *ngIf="registerBusiness.businessCode" appearance="outline" class="w-100 disbledCls">
                      <mat-label>Your unique ID</mat-label>
                      <input matInput id="businessCode" readonly formControlName="businessCode"
                        [(ngModel)]="registerBusiness.businessCode" />
                    </mat-form-field>

                    <!-- ───────── BUSINESS CATEGORY ───────── -->
                    <mat-form-field appearance="outline" class="w-100"
                      [ngClass]="{'disbledCls': showsiteform || updateButton}">
                      <mat-label>Business Category</mat-label>
                      <mat-select formControlName="category" [(ngModel)]="businessCategory.businessCategoryID"
                        (selectionChange)="getBusinessTypesByCategory()">
                        <mat-option value="undefined" disabled>Select Business Category</mat-option>
                        <mat-option *ngFor="let cat of businessCategories" [value]="cat.id">
                          {{ cat.name }}
                        </mat-option>
                      </mat-select>

                      <mat-hint *ngIf="f.category.invalid">
                        <i>Select business category</i>
                      </mat-hint>
                      <mat-hint *ngIf="f.category.valid">
                        <i>Business category selected</i>
                      </mat-hint>

                      <mat-error
                        *ngIf="(submitted || f.category.touched || f.category.dirty) && f.category.hasError('required')">
                        Business category is <i>required</i>.
                      </mat-error>
                    </mat-form-field>

                    <!-- ───────── BUSINESS TYPE ───────── -->
                    <mat-form-field appearance="outline" class="w-100"
                      [ngClass]="{'disbledCls': showsiteform || updateButton}">
                      <mat-label>Business Type</mat-label>
                      <mat-select id="businessType" formControlName="businessType"
                        [(ngModel)]="businessType.businessTypeID">
                        <mat-option value="undefined" disabled>Select Business Type</mat-option>
                        <mat-option *ngFor="let type of dupbusinessTypes" [value]="type.id">
                          {{ type.name }}
                        </mat-option>
                      </mat-select>

                      <mat-hint *ngIf="f.businessType.invalid">
                        <i>Select business type</i>
                      </mat-hint>
                      <mat-hint *ngIf="f.businessType.valid">
                        <i>Business type selected</i>
                      </mat-hint>

                      <mat-error
                        *ngIf="(submitted || f.businessType.touched || f.businessType.dirty) && f.businessType.hasError('required')">
                        Business type is <i>required</i>.
                      </mat-error>
                    </mat-form-field>

                    <!-- ───────── COUNTRY (autocomplete) ───────── -->
                    <mat-form-field appearance="outline" class="w-100"
                      [ngClass]="{'disbledCls': showsiteform || updateButton}">
                      <mat-label>Country Selection</mat-label>
                      <input matInput id="country" autocomplete="off" formControlName="countryName"
                        [matAutocomplete]="autoCountry" (focus)="filteredOptions=countries"
                        (keyup)="filterCountries()" />

                      <mat-autocomplete #autoCountry="matAutocomplete"
                        (optionSelected)="countrySelected($event.option.value)">
                        <mat-option *ngFor="let c of filteredOptions" [value]="c">
                          {{ c.name }}
                        </mat-option>
                      </mat-autocomplete>

                      <mat-hint *ngIf="f.countryName.invalid">
                        <i>Select country</i>
                      </mat-hint>
                      <mat-hint *ngIf="f.countryName.valid">
                        <i>Country selected</i>
                      </mat-hint>

                      <mat-error
                        *ngIf="(submitted || f.countryName.touched || f.countryName.dirty) && f.countryName.hasError('required')">
                        Required.
                      </mat-error>
                    </mat-form-field>

                    <!-- ───────── DIAL CODE (readonly) ───────── -->
                    <mat-form-field appearance="outline" class="w-100 dialcode-farm-element"
                      [ngClass]="{'disbledCls': showsiteform || updateButton}">
                      <mat-label>Dial Code</mat-label>
                      <input matInput id="dialCode" readonly formControlName="dialCode"
                        [(ngModel)]="registerBusiness.dialingCode" />
                    </mat-form-field>

                  </div>
                </div>

                <!-- === Section: Contact Details === -->
                <div class="form-section">
                  <h3 class="section-title">Contact Details</h3>
                  <div class="grid-three-cols">

                    <!-- Email -->
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Email ID</mat-label>
                      <input matInput id="email" autocomplete="off" formControlName="email"
                        [(ngModel)]="registerBusiness.email" />
                      <mat-error *ngIf="(submitted || f.email.touched || f.email.dirty) && f.email.errors">
                        <ng-container *ngIf="f.email.hasError('pattern')">Must be a <i>valid email</i>.</ng-container>
                      </mat-error>
                    </mat-form-field>

                    <!-- Mobile -->
                    <mat-form-field appearance="outline" class="w-100"
                      [ngClass]="{'disbledCls': showsiteform || updateButton}">
                      <mat-label>Mobile Number</mat-label>
                      <input matInput id="mobileNumber" autocomplete="off" formControlName="mobilenumber"
                        [(ngModel)]="registerBusiness.mobileNumber" />
                      <mat-error
                        *ngIf="(submitted || f.mobilenumber.touched || f.mobilenumber.dirty) && f.mobilenumber.errors">
                        <ng-container *ngIf="f.mobilenumber.hasError('required')">Mobile number is
                          <i>required</i>.</ng-container>
                        <ng-container *ngIf="f.mobilenumber.hasError('pattern')">Enter a <i>valid mobile
                            number</i>.</ng-container>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>